import { NavLink, useLocation } from "react-router-dom";
import { BookOpenCheck, ClipboardCheck, Heart, Tablet } from "lucide-react";

// Compact switcher that lives at the top of each church-resource dashboard so a
// coordinator working in one tool (say the Tracker) can jump straight into
// another (Prayer / Attendance / Kiosk) without navigating home. The active
// tool is derived from the current URL so it lights up automatically.

const TOOLS = [
  { key: "tracker",    to: "/crm/first-steps", label: "Tracker",    icon: BookOpenCheck, match: (p) => p.startsWith("/crm") },
  { key: "attendance", to: "/attendance",      label: "Attendance", icon: ClipboardCheck, match: (p) => p.startsWith("/attendance") },
  { key: "prayer",     to: "/prayer-admin",    label: "Prayer",     icon: Heart,          match: (p) => p.startsWith("/prayer-admin") },
  { key: "kiosk",      to: "/kiosk-launch",    label: "Kiosk",      icon: Tablet,         match: (p) => p.startsWith("/kiosk-launch") || p.startsWith("/kiosk/") },
];

export default function ChurchToolsSwitcher() {
  const { pathname } = useLocation();
  return (
    <nav
      className="inline-flex items-center gap-1 p-1 rounded-full max-w-full overflow-x-auto"
      style={{ background: "var(--surface-hover)", border: "1px solid var(--border-subtle)" }}
      data-testid="church-tools-switcher"
      aria-label="Church resource tools"
    >
      {TOOLS.map((t) => {
        const Icon = t.icon;
        const active = t.match(pathname);
        return (
          <NavLink
            key={t.key}
            to={t.to}
            className="inline-flex shrink-0 items-center gap-1.5 px-3 py-1.5 rounded-full text-xs transition-colors"
            style={{
              background: active ? "var(--ink)" : "transparent",
              color: active ? "var(--bg-base)" : "var(--ink-2)",
              fontWeight: active ? 600 : 400,
            }}
            data-testid={`tool-switch-${t.key}`}
            aria-current={active ? "page" : undefined}
          >
            <Icon size={13} />
            <span>{t.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
